import FeatureGates, {
    FeatureGateEnvironment,
    Identifiers
} from '@atlassian/feature-gate-js-client';
import { get } from 'lodash';
import Logger from '../logger';

interface EnvConfig {
    apiKey: string;
    environment: FeatureGateEnvironment;
}
export let statsigInitialized = false;
const getEnvironmentConfig = (): EnvConfig => {
    const environment = get(window, 'MICROS_ENVTYPE') || 'dev';
    const STATSIG_CLIENT_API_KEY = get(window, 'STATSIG_CLIENT_API_KEY');
    switch (environment) {
        case 'prod':
            return {
                apiKey: STATSIG_CLIENT_API_KEY,
                environment: FeatureGateEnvironment.Production
            };
        case 'staging':
            return {
                apiKey: STATSIG_CLIENT_API_KEY,
                environment: FeatureGateEnvironment.Staging
            };
        case 'dev':
        default:
            return {
                apiKey: STATSIG_CLIENT_API_KEY,
                environment: FeatureGateEnvironment.Development
            };
    }
};
export const initialiseStatsigClient = async () => {
    if (FeatureGates.initializeCalled() && FeatureGates.initializeCompleted()) {
        return null;
    }
    const analyticsAnonymousId = window?.localStorage
        ?.getItem('STATSIG_STABLE_ID')
        ?.replace(/"/g, '') as string;
    const envConfig: EnvConfig = getEnvironmentConfig();
    const identifiers: Identifiers = {
        analyticsAnonymousId: analyticsAnonymousId
    };
    const customAttributes = {
        analyticsAnonymousId: analyticsAnonymousId
    };

    if (!envConfig.apiKey) {
        statsigInitialized = false;
        Logger.error(
            '[sac-infra] STATSIG client Initialization Error , Missing Client Key'
        );
        return;
    }

    try {
        const options = {
            ...envConfig,
            targetApp: 'sac-infrastructure_web'
        };
        await FeatureGates.initialize(options, identifiers, customAttributes);
        statsigInitialized = true;
        Logger.info('[sac-infra] STATSIG client Initialized');
    } catch (error) {
        statsigInitialized = false;
        Logger.error('[sac-infra] STATSIG client Initialization ERROR', error);
    }
};

export const getFeatureGate = async (
    gateKey: string,
    gateDefaultValue: boolean
) => {
    if (statsigInitialized) {
        return FeatureGates.checkGate(gateKey);
    } else {
        await initialiseStatsigClient();
        if (statsigInitialized) {
            return FeatureGates.checkGate(gateKey);
        } else {
            return gateDefaultValue;
        }
    }
};
